module.exports = __webpack_public_path__ + "img/books-medical.e2b69ef5.svg";